/* eslint-disable */
import React, { useMemo, useState, useEffect } from 'react';
import { CTitle, STitle } from '../../components/Widget';
import sectionBg1 from '../../../../../../assets/education/topic1000/section3_bg2.svg';
import sectionBg3 from '../../../../../../assets/education/topic1000/section3_bg3.png';
import arrow from '../../../../../../assets/2025/arrow.gif';
import { Modal } from 'antd';
import link1 from '../../../../../../assets/education/topic1000/link1.png';
import link1CN from '../../../../../../assets/education/topic1000/link1-1.png';
import link2 from '../../../../../../assets/education/topic1000/link2.png';
import link3 from '../../../../../../assets/education/topic1000/link3.png';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import { useStore } from '../../../../store';
interface ISection2Props {
  settings: any;
}

interface CaseContent {
  id: number;
  text: string;
  link?: string;
  tip?: string;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const { language } = useStore();
  const linkMap: Record<string, string> = {
    '1': language === 'tc' ? link1CN : link1,
    '2': link2,
    '3': link3,
  };
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();

  const [activeTab, setActiveTab] = useState<'A' | 'B'>('A');
  const [open, setOpen] = useState<boolean>(false);
  const [linkPic, setLinkPic] = useState<string>();
  // 使用对象来分别跟踪每个tab的已点击链接
  const [clickedLinks, setClickedLinks] = useState<Record<string, Set<string>>>(
    {
      A: new Set(),
      B: new Set(),
    }
  );
  const [clickedTab, setClickedTab] = useState<Boolean>(false);

  const [state, setState] = useState({
    deepfakeFlag: false,
    deepfakeFlag2: false,
  });

  React.useEffect(() => {
    if (state.deepfakeFlag && state.deepfakeFlag2) {
      updateComponentState(p_course, p_topic, ID, 'education-iws-section2-2');
    }
  }, [p_course, p_topic, state]);
  // 获取当前tab的所有带链接的内容项
  const getCurrentTabContent = (): CaseContent[] => {
    if (activeTab === 'A') {
      return paragraphsSettings.caseAContent || [];
    } else {
      return paragraphsSettings.caseBContent || [];
    }
  };

  const currentTabContent = getCurrentTabContent();

  // 自定义Tab组件
  const CustomTab = ({
    title,
    isActive,
  }: {
    title: string;
    isActive: boolean;
  }) => <div className={`custom-tab ${isActive ? 'active' : ''}`}>{title}</div>;

  // 显示图片模态框
  const showPicFn = (item: CaseContent) => {
    setOpen(true);
    setLinkPic(linkMap[item.link || '']);

    // 记录当前tab已点击的链接
    if (item.link) {
      setClickedLinks((prev) => ({
        ...prev,
        [activeTab]: new Set(prev[activeTab]).add(item.link!),
      }));
    }
  };

  // 渲染内容列表
  const renderContentList = (contentList: CaseContent[]) => (
    <div className="content-list">
      {contentList.map((item, index) => (
        <div key={item.id + index} className="content-item">
          <div className="content-item-flex">
            <div className={`text text-${activeTab}`}>{item.text}</div>
            {item.link && (
              <div className={`link link-${activeTab}`}>
                <span className="content-pic" onClick={() => showPicFn(item)}>
                  {/* {paragraphsSettings.clickToViewImage} */}
                  <img src={linkMap[item.link]} alt="" />
                </span>
                <div>{item.tip}</div>
                {/* 只有未点击过的链接才显示箭头 */}
                {/* {!clickedLinks[activeTab].has(item.link) && (
                  <span className="content-arrow"></span>
                )} */}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );

  // 渲染启示列表
  const renderRevelationList = (caseRevelationContent: CaseContent[]) => (
    <div className="revelation-list">
      {caseRevelationContent?.map((item, i) => (
        <div key={item.id} className="revelation-item">
          <span className="id">0{item.id}</span>
          <span className="text"> {item.text}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div className="topic-section-2 topic-section-2-en">
      <div className="tool-title">
        <CTitle title={paragraphsSettings.title} />
      </div>

      <div className="tabs-content" id="education-iws-section2-1">
        {/* Tab栏 */}
        <div className="custom-tabs-header">
          {(['A', 'B'] as const).map((tab) => (
            <div
              key={tab}
              className={`custom-tab-item ${activeTab !== tab ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(tab);
                setClickedTab(true);
                updateComponentState(p_course, p_topic, ID, 'education-iws-section2-1');
              }}
            >
              <CustomTab
                title={
                  paragraphsSettings[
                    tab === 'A' ? 'leftTabTitle' : 'rightTabTitle'
                  ]
                }
                isActive={activeTab !== tab}
              />
            </div>
          ))}
          {!clickedTab && <img className="arrow" src={arrow} alt="" />}
        </div>

        {/* Tab内容区域 */}
        <div className="tabs-style">
          <div className="tab-a">
            <div className="tab-a-title">
              {activeTab === 'A'
                ? paragraphsSettings.l2
                : paragraphsSettings.r2}
            </div>
            <div className="tab-a-content">
              <div className="tab-a-content-left"></div>
              <div className="tab-a-content-right">
                {renderContentList(currentTabContent)}
              </div>
            </div>
          </div>

          <div className="tab-revelation">
            <STitle title={paragraphsSettings.caseInsights} />
            <div className="tab-revelation-content">
              <img
                className="tab-revelation-content-img"
                src={sectionBg1}
                alt=""
              />
              <div className="tab-revelation-content-text">
                {renderRevelationList(
                  activeTab === 'A'
                    ? paragraphsSettings.caseRevelationContent || []
                    : paragraphsSettings.caseRevelationContentTab2 || []
                )}
              </div>
            </div>
          </div>
          <img className="pic" src={sectionBg3} alt="" />
        </div>
      </div>

      <div className="case-study" id="education-iws-section2-2">
        <STitle title={paragraphsSettings.caseStudy} />
        <div
          className="case-study-left"
          onClick={() => setState({ ...state, deepfakeFlag: true })}
        >
          {!state.deepfakeFlag && <img src={arrow} alt="" />}
          {state.deepfakeFlag && (
            <span className="focus-in-expand-fwd">
              {paragraphsSettings?.caseStudy1}
            </span>
          )}
        </div>
        <div
          className="case-study-right"
          onClick={() => setState({ ...state, deepfakeFlag2: true })}
        >
          {!state.deepfakeFlag2 && <img src={arrow} alt="" />}
          {state.deepfakeFlag2 && (
            <span className="focus-in-expand-fwd">
              {paragraphsSettings?.caseStudy2}
            </span>
          )}
        </div>
      </div>

      <Modal
        title={''}
        width={'80%'}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        <img src={linkPic} alt="" />
      </Modal>
    </div>
  );
};

export default Section2;
